import { z } from "zod";
// The two sites one deployment serves. Resolution is by Host (server/src/core/sites.ts);
// nothing here is ever derived from a URL path.
export const SITE_IDS = ["myfirstagent", "launchyouragent"];
export const SiteIdSchema = z.enum(SITE_IDS);
export const LOCALES = ["en", "es"];
export const LocaleSchema = z.enum(LOCALES);
export const SiteSchema = z.object({
    id: SiteIdSchema,
    name: z.string(),
    shortName: z.string(),
    defaultLocale: LocaleSchema,
    supportedLocales: z.array(LocaleSchema),
});
export const SITES = {
    myfirstagent: {
        id: "myfirstagent",
        name: "My First Agent",
        shortName: "MFA",
        defaultLocale: "en",
        supportedLocales: ["en", "es"],
    },
    launchyouragent: {
        id: "launchyouragent",
        name: "Launch Your Agent",
        shortName: "LYA",
        defaultLocale: "en",
        supportedLocales: ["en", "es"],
    },
};
export function isSiteId(value) {
    return SITE_IDS.includes(value);
}
//# sourceMappingURL=sites.js.map